$(function(){
  let mySwiper = new Swiper ('.swiper', {
    loop: true,
    centeredSlides: true,
    slidesPerView: "auto",
    navigation: { 
      nextEl: '.swiper-button-next', 
      prevEl: '.swiper-button-prev', 
    },
    autoplay: {
      delay: 4000,
    },
  });
  let detailMainSlideshowThumbs = new Swiper ('.js-detail-page-slideshow-thumbs', {
    watchSlidesProgress: true,
    preventClicks: false,
    slidesPerView: 8,
    allowTouchMove: false
  });
  let detailMainSlideshow = new Swiper ('.js-detail-page-slideshow', {
    loop: true,
    pagination: {
      el: ".swiper-detail-page-slideshow-pagination",
      type: "fraction",
    },
    navigation: { 
      nextEl: '.swiper-detail-page-slideshow-button-next', 
      prevEl: '.swiper-detail-page-slideshow-button-prev', 
    },
    thumbs: {
      swiper: detailMainSlideshowThumbs,
    }
  });
  let detailMainSlideshowThumbs2 = new Swiper ('.js-detail-page-slideshow-2-thumbs', {
    watchSlidesProgress: true,
    preventClicks: false,
    slidesPerView: 8,
    allowTouchMove: false
  });
  let detailMainSlideshow2 = new Swiper ('.js-detail-page-slideshow-2', {
    loop: true,
    pagination: {
      el: ".swiper-detail-page-slideshow-2-pagination",
      type: "fraction",
    },
    navigation: { 
      nextEl: '.swiper-detail-page-slideshow-2-button-next', 
      prevEl: '.swiper-detail-page-slideshow-2-button-prev', 
    },
    thumbs: {
      swiper: detailMainSlideshowThumbs2,
    }
  });
  let reccomendSwiper = new Swiper ('.js-reccomend-caroucel', {
    loop: false,
    slidesPerView: "auto",
    freeMode: {
      enabled: true,
      sticky: true,
      minimumVelocity: 0.01, // 最小タッチ速度
      momentumRatio: 1.0, // 値を大きくすると、スライダーを離した後の運動量距離が大きくなる
      momentumVelocityRatio: 0.70, // 値を大きくすると、スライダーを離した後の速度が大きくなる
      momentumBounce: true, // https://swiperjs.com/swiper-api　　　　　http://www.testsite.bics-net.co.jp/data/pdf/swiperJS_optionlist.pdf
      momentumBounceRatio: 1.5 // 値が大きいほど、バウンス効果が大きくなる
    },
    navigation: { 
      nextEl: '.swiper-reccomend-button-next', 
      prevEl: '.swiper-reccomend-button-prev', 
    },
  });
  let reccomend2Swiper = new Swiper ('.js-reccomend-caroucel-2', {
    loop: false,
    slidesPerView: "auto",
    freeMode: {
      enabled: true,
      sticky: true,
      minimumVelocity: 0.01, // 最小タッチ速度
      momentumRatio: 1.0, // 値を大きくすると、スライダーを離した後の運動量距離が大きくなる
      momentumVelocityRatio: 0.70, // 値を大きくすると、スライダーを離した後の速度が大きくなる
      momentumBounce: true, // https://swiperjs.com/swiper-api　　　　　http://www.testsite.bics-net.co.jp/data/pdf/swiperJS_optionlist.pdf
      momentumBounceRatio: 1.5 // 値が大きいほど、バウンス効果が大きくなる
    },
    navigation: { 
      nextEl: '.swiper-reccomend2-button-next', 
      prevEl: '.swiper-reccomend2-button-prev', 
    },
  });
  let relatedSwiper = new Swiper ('.js-related-caroucel', {
    loop: false,
    slidesPerView: "auto",
    freeMode: {
      enabled: true,
      sticky: true,
      minimumVelocity: 0.01, // 最小タッチ速度
      momentumRatio: 1.0, // 値を大きくすると、スライダーを離した後の運動量距離が大きくなる
      momentumVelocityRatio: 0.70, // 値を大きくすると、スライダーを離した後の速度が大きくなる
      momentumBounce: true, // https://swiperjs.com/swiper-api　　　　　http://www.testsite.bics-net.co.jp/data/pdf/swiperJS_optionlist.pdf
      momentumBounceRatio: 1.5 // 値が大きいほど、バウンス効果が大きくなる
    },
    navigation: { 
      nextEl: '.swiper-related-button-next', 
      prevEl: '.swiper-related-button-prev', 
    },
  });
  if (window.matchMedia('(max-width: 768px)').matches) {
    var bannerSwiper = new Swiper('.js-banner-caroucel', {
      loop: false,
      slidesPerView: "auto",
      freeMode: {
        enabled: true,
        sticky: true,
        minimumVelocity: 0.01, // 最小タッチ速度
        momentumRatio: 1.0, // 値を大きくすると、スライダーを離した後の運動量距離が大きくなる
        momentumVelocityRatio: 0.70, // 値を大きくすると、スライダーを離した後の速度が大きくなる
        momentumBounce: true, // https://swiperjs.com/swiper-api　　　　　http://www.testsite.bics-net.co.jp/data/pdf/swiperJS_optionlist.pdf
        momentumBounceRatio: 1.5 // 値が大きいほど、バウンス効果が大きくなる
      },
    });
  }
});
